import { withStyles, BodyText, Preview } from 'vopay';
import { PreviewOption, SavedBrandingByProduct, usePreviewLabels } from './buildPreviewOptions.helper';
import styles from './PreviewSelector.module.scss';

const cn = withStyles(styles);

const THUMBNAIL_WIDTH = 84;
const THUMBNAIL_HEIGHT = 58;

type PreviewSelectorProps = {
  options: PreviewOption[];
  selectedKey: string;
  savedBranding: SavedBrandingByProduct;
  onSelect: (option: PreviewOption) => void;
};

export default function PreviewSelector({ options, selectedKey, savedBranding, onSelect }: PreviewSelectorProps) {
  const labels = usePreviewLabels();

  return (
    <div className={cn('selector')}>
      {options.map((option) => {
        const isSelected = option.key === selectedKey;
        const values = savedBranding[option.productType];

        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={isSelected}
            data-testid={`branding-preview-tile-${option.key}`}
            className={cn('tile', isSelected && 'tileSelected')}
            onClick={() => onSelect(option)}
          >
            <span className={cn('thumbnail')}>
              <Preview
                preview={option.previewType}
                logo={values?.Logo || ''}
                primaryColor={values?.PrimaryColor || ''}
                secondaryColor={values?.SecondaryColor || ''}
                width={THUMBNAIL_WIDTH}
                height={THUMBNAIL_HEIGHT}
                slideShow={false}
              />
            </span>

            <BodyText
              size="sm"
              weight={isSelected ? 'em' : 'rg'}
              className={cn('label', isSelected && 'labelSelected')}
            >
              {labels[option.labelKey]}
            </BodyText>
          </button>
        );
      })}
    </div>
  );
}
